import {connect} from 'react-redux'
import InternationalPhonereloadView from '../components/InternationalPhonereloadView'
import _ from 'lodash'
import SimpExp from '../../../../helpers/external/simpexp'

import {C} from "../../../../helpers";
import {changeStep} from "../../../../layouts/Content/modules/step";
import {submitTransaction} from '../modules/international_phonereload'
import {appSetVal, appSetServerVal, appSetObj, appCall, checkFields} from '../../../../store/application';

const mapDispatchToProps = {
  appCall: appCall,
  appSetServerVal: appSetServerVal,
  appSetVal: appSetVal,
  appSetObj: appSetObj,
  changeStep: changeStep,
  checkFields: checkFields,

  submitTransaction: submitTransaction
};

const mapStateToProps = (state) => {
  const {ready_to_submit, account, recipient_number, phone_number_validation, recipient_number_error,
    sender_number} = state.app.x_data;

  const {customer_id, phone_number} = state.customer;

  const {icon, title, product_denom_mapping, mask} = state.app.product_data;

  return {
    icon,
    title,
    customer_id,
    denominations: _.map(product_denom_mapping, (v, k) => ({key: k, text: C(v[0], '$'), amount: v[0], value: k})),
    ready_to_submit: !ready_to_submit,
    phone_number,
    account,
    input_mask: new SimpExp(mask).gen('ї'),
    recipient_number,
    sender_number,
    recipient_number_error: recipient_number_error || (phone_number_validation && phone_number_validation.type),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(InternationalPhonereloadView)


// WEBPACK FOOTER //
// ./src/components/Applications/InternationalPhonereload/containers/InternationalPhonereloadContainer.js